import { create } from 'zustand'

interface DropdownLocationSweepstakes {
  dropdownLocationSweepstakesValue: string
  setdropdownLocationSweepstakesValue: (
    dropdownLocationSweepstakesValue: string
  ) => void
}

export const useDropdownLocationSweepstakesStore =
  create<DropdownLocationSweepstakes>((set) => ({
    dropdownLocationSweepstakesValue: '',
    setdropdownLocationSweepstakesValue: (
      dropdownLocationSweepstakesValue: any
    ) => {
      set({ dropdownLocationSweepstakesValue })
    },
  }))
